/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { extractRoles, hasProjectPermission, ProjectPermission, ProjectPermissions } from 'shared';

import { RootState } from '../store';

export const useProjectPermissions = (organizationId: string, projectId: string) => {
  const { user } = useSelector((state: RootState) => state.auth);

  return useMemo(() => {
    const roles = extractRoles(user?.organizations ?? [], organizationId, projectId);
    return ProjectPermissions.reduce(
      (acc, permission) => ({
        ...acc,
        [permission]: hasProjectPermission(roles.organizationRoles, roles.projectRoles, permission),
      }),
      {} as Record<ProjectPermission, boolean>,
    );
  }, [user, organizationId, projectId]);
};
